import { Star } from "lucide-react";
import { useTranslation } from "react-i18next";

const TestimonialsSection = () => {
  const { t } = useTranslation();
  const items = t("testimonials.items", { returnObjects: true }) as { name: string; company: string; text: string }[];

  return (
    <section className="py-12 md:py-20 lg:py-28 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">{t("testimonials.title")}</h2>
          <p className="text-muted-foreground text-sm md:text-lg">{t("testimonials.subtitle")}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto">
          {items.map((item, i) => (
            <div key={i} className="bg-card rounded-xl p-5 md:p-8 shadow-lg border border-border">
              <div className="flex gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Star key={j} className="w-5 h-5 fill-accent text-accent" />
                ))}
              </div>
              <p className="text-foreground leading-relaxed mb-6 italic">"{item.text}"</p>
              <div>
                <p className="font-semibold text-foreground">{item.name}</p>
                <p className="text-muted-foreground text-sm">{item.company}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
